// Brick recipe — Buildings Set1 §7.4: running-bond courses with mortar. Uses the new `brickBond`
// primitive (a prelude-layer-body primitive composing domainRepeatAxis + hash01 + rampVal, so it
// is strictly additive — terrain + pre-existing recipes emit byte-identical GLSL). Immutable
// built-in root (never mutate — extend/fork instead).
//
// A brick wall's realism is the COURSE STRUCTURE + the mortar groove: bold, regular, and read at
// wall distance. Colour is a modest per-brick jitter within a narrow terracotta ramp (real brick
// varies a few percent in value, not wildly). `flatGeoNormal` is left false (a brick wall's
// geometric normal IS the wall face; the material's own relief shades it).
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const BRICK_RECIPE_ID = "brick";

export const brickRecipe = new MaterialRecipe({
	id: BRICK_RECIPE_ID,
	name: "Brick",
	roughness: 0.8,
	specStrength: 0, // matte clay — no coherent highlight (see Recipe_Dirt)

	params: [
		new ParamSchema({key: "brick_length", label: "Brick length (m)", kind: "scalar", min: 0.08, max: 1, default: 0.23}),
		new ParamSchema({key: "brick_height", label: "Brick height (m)", kind: "scalar", min: 0.02, max: 0.3, default: 0.066}),
		new ParamSchema({key: "stagger", label: "Course stagger", kind: "scalar", min: 0, max: 1, default: 0.5}),
		new ParamSchema({key: "mortar_width", label: "Mortar width (m)", kind: "scalar", min: 0, max: 0.02, default: 0.006}),
		new ParamSchema({key: "mortar_depth", label: "Mortar depth (m)", kind: "scalar", min: -0.02, max: 0, default: -0.003}),
		new ParamSchema({key: "brick_relief", label: "Brick relief (m)", kind: "scalar", min: 0, max: 0.05, default: 0.002}),
		new ParamSchema({key: "brick_ramp", label: "Brick ramp", kind: "ramp", default: [0, 0.45, 0.16, 0.08, 0.4, 0.52, 0.2, 0.1, 0.75, 0.6, 0.26, 0.13, 1, 0.5, 0.2, 0.09]}),
		new ParamSchema({key: "mortar_color", label: "Mortar colour", kind: "color", default: [0.72, 0.7, 0.66]}),
	],
	layers: [
		new MaterialLayer({
			id: "bonds",
			primitive: "brickBond",
			args: {
				brickLength: {ref: "brick_length"},
				brickHeight: {ref: "brick_height"},
				stagger: {ref: "stagger"},
				mortarWidth: {ref: "mortar_width"},
				mortarDepth: {ref: "mortar_depth"},
				brickRelief: {ref: "brick_relief"},
				brickRamp: {ref: "brick_ramp"},
				mortarColor: {ref: "mortar_color"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
